import axios from "../axiosConfig";

class Routes {


    getAllProjects = (params) => {
        let data = axios.get("/api/projects/", { params })
        return data;
    };
    getProjectById = (id) => {
        let data = axios.get(`/api/projects/${id}`);
        return data;

    };
    createProject = (val) => {
        let data = axios.post("/api/projects/", val)
        return data;
    };
    updateProject = (id, val) => {
        let data = axios.put(`/api/projects/${id}`, val);
        return data;
    };
    deleteProject = (id) => {
        const data = axios.delete(`/api/projects/${id}`)
        return data
    };



}



export default new Routes();
